<div class="unsaved-dialog text-center">
    <h1>{{title}}</h1>
    <div>
        <p>{{message}}</p>
    </div>
    <div align="center">
        <button color="primary" class="btn btn-fill common-button me-2" (click)="closeModal()">No Thanks</button>
        <button color="warn" class="btn btn-border common-button" (click)="reload()">Yes</button>
    </div>
</div>